
import { computed, defineComponent } from 'vue';

import { VCodeService } from '@/services/vcode.service';
import { useService } from '@kaokei/use-vue-service';

import { phonePattern, imageCodePattern } from '@/utils';

export default defineComponent({
  name: 'VCode',
  props: {
    phone: {
      type: String,
    },
    imgCode: {
      type: String,
    },
  },
  setup(props: { phone?: string; imgCode?: string }, { emit }) {
    // 这里的验证码服务是当前组件的，而不是从父组件获取
    // declareProviders([VCodeService]);

    const vcodeService = useService(VCodeService);

    const isValid = computed(() => {
      return (
        props.phone &&
        phonePattern.test(props.phone) &&
        props.imgCode &&
        imageCodePattern.test(props.imgCode)
      );
    });

    const isActive = computed(() => {
      return isValid.value && vcodeService.countdownStatus === 'initial';
    });

    const onClickBtn = () => {
      if (isValid.value && props.phone && props.imgCode) {
        vcodeService.sendVerifiedCode({
          phone: props.phone,
          imgCode: props.imgCode,
          errFun: () => {
            vcodeService.getImageCode();
            emit('clearCode');
          },
        });
      }
    };

    const btnText = computed(() =>
      vcodeService.countdownStatus === 'countdown'
        ? `${vcodeService.countdownTime}s后重发`
        : '获取验证码'
    );

    return {
      isActive,
      onClickBtn,
      btnText,
    };
  },
});
